import React, { useEffect, useState } from 'react';
import { IconButton } from 'common-ui-modules';
const AnchorNav = () => {
    const [headings, setHeadings] = useState([]);
    const [expandedHeadings, setExpandedHeadings] = useState({});

    useEffect(() => {
        const divElements = document.querySelectorAll('div[id] > .h-100 > h2, div[id] > .h-100 > h3');
        const headingList = Array.from(divElements).map((heading) => {
            const div = heading.closest('div[id]');
            return {
                id: div.id,
                text: heading.textContent,
                level: parseInt(heading.tagName.replace('H', ''), 10)
            };
        });
        setHeadings(headingList);
    }, []);

    const getHighestLevel = (headings) => {
        return Math.min(...headings.map(heading => heading.level));
    };

    const toggleExpand = (id) => {
        setExpandedHeadings(prevState => ({
            ...prevState,
            [id]: !prevState[id]
        }));
    };

    const renderHeadings = (headings, currentLevel) => {
        const result = [];
        let currentIndex = 0;

        while (currentIndex < headings.length)
        {
            const heading = headings[currentIndex];

            if (heading.level === currentLevel)
            {
                const nestedHeadings = [];
                currentIndex++;

                while (
                    currentIndex < headings.length &&
                    headings[currentIndex].level > currentLevel
                )
                {
                    nestedHeadings.push(headings[currentIndex]);
                    currentIndex++;
                }

                const isExpanded = expandedHeadings[heading.id] || false;

                result.push(
                    <div className="d-flex align-items-center" key={heading.id}>
                        <li key={heading.id} className={`ml-${ (currentLevel - 1) * 2 }`}>
                            {/* Expand/Collapse Icon */}
                            {nestedHeadings.length > 0 && nestedHeadings[0].level === currentLevel + 1 && (
                                <IconButton
                                    onClick={() => toggleExpand(heading.id)}
                                    icon={isExpanded ? "arrowUpIcon" : "arrowDownIcon"}
                                    className={'mr-2 me-1 align-baseline p-0 btn btn-unstyled'}
                                />
                            )}

                            {/* Heading Link */}
                            <a
                                href={`#${ heading.id }`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    const element = document.getElementById(heading.id);
                                    if (element)
                                    {
                                        element.scrollIntoView({ behavior: "smooth" });
                                        window.history.replaceState(null, "", `#${ heading.id }`);
                                    }
                                }}
                                className={nestedHeadings.length > 0 ? "ms-1" : ""}
                            >
                                {heading.text}
                            </a>

                            {/* Render nested headings if expanded */}
                            {isExpanded &&
                                nestedHeadings.length > 0 &&
                                renderHeadings(nestedHeadings, currentLevel + 1)}
                        </li>
                    </div>
                );
            } else
            {
                currentIndex++;
            }
        }

        return <ul>{result}</ul>;
    };

    const highestLevel = getHighestLevel(headings);

    return (
        <div className="anchor-nav">
            {headings.length > 0 && (
                <>
                    <h2 className='mb-4'>On this page</h2>
                    {renderHeadings(headings, highestLevel)}
                </>
            )}
        </div>
    );
};

export default AnchorNav;